import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";

// Pill button rendered as a router link.
export function Btn({
  to,
  href,
  variant = "primary",
  size = "md",
  className,
  children,
  withArrow = false,
  onClick,
  ...rest
}) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-bold tracking-tight transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mint focus-visible:ring-offset-2 disabled:opacity-60";
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm md:text-base",
    lg: "px-8 py-4 text-base",
  };
  const variants = {
    primary:
      "bg-lime text-forest hover:bg-bright-green shadow-[0_8px_24px_rgba(141,254,63,0.35)] hover:shadow-[0_10px_30px_rgba(52,237,93,0.4)] hover:-translate-y-0.5",
    secondary:
      "bg-white text-forest border border-border-neutral hover:border-mint hover:-translate-y-0.5",
    dark: "bg-forest text-white hover:bg-dark-neutral hover:-translate-y-0.5",
    ghostLight:
      "bg-white/10 text-white border border-white/20 hover:bg-white/20 backdrop-blur",
  };
  const classes = cn(base, sizes[size], variants[variant], className);
  const content = (
    <>
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" />}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} className={classes} onClick={onClick} {...rest}>
      {content}
    </Link>
  );
}

export function Eyebrow({ children, className, dark = false }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.18em]",
        dark ? "text-mint" : "text-mid-neutral",
        className
      )}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          dark ? "bg-lime" : "bg-mint"
        )}
      />
      {children}
    </span>
  );
}

export function SectionHeading({ children, className, dark = false }) {
  return (
    <h2
      className={cn(
        "text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.08] text-balance",
        dark ? "text-white" : "text-forest",
        className
      )}
    >
      {children}
    </h2>
  );
}
